import { useState } from 'react';

import ClubMemberRequirementsData from './ClubMemberRequirementsData';

const useClubMemberRequirementsData = () => {
  const [clubMemberRequirementsState, setClubMemberRequirementsState] = useState(ClubMemberRequirementsData.INITIAL_CLUB_MEMBER_REQUIREMENTS_STATE);

  const getClubMemberRequirements = (orgUnitId) => {
    return ClubMemberRequirementsData.getClubMemberRequirementsData(orgUnitId, clubMemberRequirementsState, setClubMemberRequirementsState);
  };

  return {
    clubMemberRequirementsState,
    getClubMemberRequirements
  };
};

export default useClubMemberRequirementsData;